<template>
  <div class="v-container">
    <div class="loadding-spin" v-if="loading">
      <Circle4></Circle4>
    </div>
    <div class="card">
      <div class="card-body">
        <div class="title-body">
          <h3>DANH SÁCH QR SCAN</h3>
          <div class="title-btn">
            <el-button @click="fn_tableShowFormSearch()" icon="el-icon-search"
              >ẩn/hiện tìm kiếm</el-button
            >
            <el-button
              type="primary"
              @click="fn_add()"
              icon="el-icon-circle-plus-outline"
              >thêm mới qr</el-button
            >
          </div>
        </div>
        <div class="main-body">
          <div class="main-body-search mb-3">
            <b-collapse
              v-bind:visible="mData.tableRules.showFormSearch"
              id="myFormSearch"
              class="b-shadow"
            >
              <b-card style="min-height: auto">
                <el-form
                  ref="myForm"
                  label-position="top"
                  @submit.native.prevent
                  label-width="100px"
                  :model="mData.tableRules.dataSearch.value"
                  :rules="mData.tableRules.dataSearch.valid"
                >
                  <b-row>
                    <b-col md="6">
                      <el-form-item label="Mã code">
                        <el-input
                          v-model="mData.tableRules.dataSearch.value['code']"
                          size="medium"
                          clearable
                          @input="forceUpdateUI"
                        ></el-input>
                      </el-form-item>
                    </b-col>
                    <b-col md="6">
                      <el-form-item label="URL">
                        <el-input
                          v-model="
                            mData.tableRules.dataSearch.value['pattern_url']
                          "
                          size="medium"
                          clearable
                          @input="forceUpdateUI"
                        ></el-input>
                      </el-form-item>
                    </b-col>
                  </b-row>
                  <el-form-item class="text-center mb-0">
                    <el-button
                      icon="el-icon-search"
                      type="primary"
                      native-type="submit"
                      v-ladda
                      @click="fn_tableSearch()"
                      >Tìm kiếm</el-button
                    >
                  </el-form-item>
                </el-form>
              </b-card>
            </b-collapse>
          </div>
          <div class="main-body-table">
            <el-table
              stripe
              :data="mData.tableRules.data"
              border
              max-height="540"
              style="width: 100%"
              @sort-change="fn_tableSortChange"
              :default-sort="{
                prop: mData.tableRules.defaultSort[0],
                order: mData.tableRules.defaultSort[1],
              }"
            >
              <el-table-column prop="" label="STT" width="50">
                <template slot-scope="scope">
                  <div class="text-center">
                    {{ mData.tableRules.offset + scope.$index + 1 }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                prop="code"
                label="Mã code"
                min-width="100"
              ></el-table-column>
              <el-table-column
                prop="pattern_url"
                label="URL"
                min-width="250"
              ></el-table-column>

              <el-table-column label="Thao tác" align="center" width="150px">
                <template slot-scope="scope">
                  <el-button
                    size="mini"
                    plain
                    @click="fn_handle('update', scope.$index, scope.row)"
                    v-b-popover.hover.left="aLang.c_update"
                    type="primary"
                  >
                    <i class="far fa-edit"></i>
                  </el-button>
                  <el-button
                    size="mini"
                    plain
                    @click="fn_handle('delete', scope.$index, scope.row)"
                    v-b-popover.hover.left="aLang.c_delete"
                    type="danger"
                  >
                    <i class="fas fa-trash-alt"></i>
                  </el-button>
                  <el-button
                    size="mini"
                    plain
                    type="warning"
                    @click="fn_handle('detail', scope.$index, scope.row)"
                    v-b-popover.hover.left="aLang.c_detail"
                  >
                    <i class="fa-light fa-qrcode"></i>
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
            <div class="mt-2 text-right" v-if="mData.tableRules.allowPaging">
              <el-pagination
                @size-change="fn_tableSizeChange"
                :page-sizes="mData.tableRules.lengthMenu"
                :page-size="mData.tableRules.limit"
                :current-page="mData.tableRules.page"
                @current-change="fn_tableCurentChange"
                @prev-click="fn_tablePrevClick"
                @next-click="fn_tableNextClick"
                background
                layout="total, sizes, prev, pager, next, jumper"
                :total="mData.tableRules.total"
                :pager-count="5"
              ></el-pagination>
            </div>
            <el-dialog
              title="QR SCAN"
              :visible.sync="dialogVisibleQR"
              :close-on-click-modal="false"
              width="30%"
              :before-close="handleClose"
            >
              <div class="qr-box">
                <qrcode-vue
                  :value="valueQR"
                  :size="sizeQR"
                  level="L"
                  class="qr-scan"
                  id="canvas"
                />
                <qrcode-vue
                  :value="valueQR"
                  :size="1200"
                  level="L"
                  class="qr-scan-download"
                />
              </div>
              <div class="qr-container-content">
                <div v-if="!showOptionQR" class="qr-content">
                  {{ this.valueQR }}
                </div>
                <el-input
                  v-if="showOptionQR"
                  placeholder="Nhập dữ liệu"
                  v-model="addValueURL"
                  style="max-width: 319px"
                  clearable
                  @input="fn_changeUrlWhenAddValueURL"
                >
                  <template slot="prepend">{{ this.valueQRTemplate }}</template>
                </el-input>

                <el-button
                  icon="el-icon-s-tools"
                  circle
                  plain
                  title="Cấu hình QRScan nâng cao"
                  @click="showOptionQR = !showOptionQR"
                ></el-button>
              </div>

              <span slot="footer" class="dialog-footer">
                <el-button
                  @click="fn_copyQR()"
                  v-if="!isCopyQR"
                  icon="el-icon-document-copy"
                  style="min-width: 120px"
                  >sao chép mã</el-button
                >

                <el-button
                  type="success"
                  icon="el-icon-check"
                  v-if="isCopyQR"
                  style="min-width: 120px"
                  >đã sao chép</el-button
                >
                <el-button
                  type="primary"
                  @click="fn_downQR"
                  icon="el-icon-download"
                  >Tải mã QR Scan</el-button
                >
              </span>
            </el-dialog>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Circle4 } from "vue-loading-spinner";
import LanguageService from "../../../service/LanguageService";
import MethodService from "../../../service/MethodService";
import DataForm from "../../../dataForm/dataFormQRScan";
import mushroom from "viettoc-api";
import moment from "moment";
import QrcodeVue from "qrcode.vue";

export default {
  data() {
    return {
      aLang: LanguageService.lang,
      loading: true,
      aElement: MethodService.element,
      dialogVisibleQR: false,
      isCopyQR: false,
      valueQR: "", // link url của qrscan
      valueQRTemplate: "", // link url của qrscan dùng cho hiển thị template
      addValueURL: "",
      sizeQR: 200,
      showOptionQR: false,
      mData: {
        tableRules: MethodService.copyObject(DataForm.tableRules),
      },
    };
  },
  components: {
    Circle4,
    QrcodeVue,
  },
  methods: {
    forceUpdateUI() {
      this.$forceUpdate();
    },
    async fn_initTable() {
      let dataFilter = {
        filters: this.mData.tableRules.filters,
        fields: "id,code,pattern_url",
      };
      if (this.mData.tableRules.allowPaging) {
        dataFilter.limit = this.mData.tableRules.limit;
        dataFilter.offset = this.mData.tableRules.offset;
      }
      if (this.mData.tableRules.allowSorting) {
        dataFilter.sort = this.mData.tableRules.sort;
      }
      if (this.mData.tableRules.showUrl) {
        this.$router
          .replace({
            name: "DanhSachQRScan",
            query: {
              limit: this.mData.tableRules.limit,
              page: this.mData.tableRules.page,
              sort: this.mData.tableRules.sort,
              filters: this.mData.tableRules.filters,
              showFormSearch: this.mData.tableRules.showFormSearch,
            },
          })
          .catch(() => {});
      }
      try {
        const response = await mushroom.qr_scan.listAsync(dataFilter);
        if (response.result) {
          response.result.forEach((item) => {
            item.urlVietToc = "";
            item.urlVietToc = "https://qr.viettoc.vn/" + item.code;
          });
          this.mData.tableRules.data = response.result;
          this.mData.tableRules.total = response.meta.total;
          this.mData.tableRules.page =
            response.meta.offset / response.meta.limit + 1;
          this.loading = false;
        }
      } catch (e) {
        this.loading = false;
        MethodService.showError(e.code);
      }
    },
    fn_tableSortChange(column, tableRules) {
      tableRules = this.mData.tableRules;
      MethodService.tableSortChange(column, tableRules);
      this.fn_initTable();
    },

    fn_formatDate(date) {
      return moment(date).format("DD/MM/YYYY HH:mm");
    },

    // tạo mới qr scan
    fn_add() {
      this.$router.push({
        name: "TaoQRScan",
      });
    },

    // phân trang
    fn_tableSizeChange(limit) {
      this.mData.tableRules.limit = limit;
      this.fn_tableChangeOffset(this.mData.tableRules.page);
    },
    fn_tableCurentChange(page) {
      this.fn_tableChangeOffset(page);
    },
    fn_tablePrevClick(page) {
      this.fn_tableChangeOffset(page);
    },
    fn_tableNextClick(page) {
      this.fn_tableChangeOffset(page);
    },
    fn_tableChangeOffset(page) {
      this.mData.tableRules.page = page;
      this.mData.tableRules.offset =
        (this.mData.tableRules.page - 1) * this.mData.tableRules.limit;
      this.fn_initTable();
    },

    // xem chi tiết, xóa bảng
    fn_handle(type, scope, row) {
      if (type == "update") {
        this.$router.push({
          name: "CapNhatQRScan",
          params: { id: row.id },
        });
      }
      if (type == "detail") {
        this.dialogVisibleQR = true;
        this.valueQR = row.urlVietToc;
        this.valueQRTemplate = row.urlVietToc;
        sessionStorage.setItem("codeQR", row.code);
      }
      if (type == "delete") {
        this.$confirm(LanguageService.lang.c_deleteConfirm, {
          confirmButtonText: LanguageService.lang.c_agree,
          cancelButtonText: LanguageService.lang.c_cancel,
          type: "warning",
        })
          .then(() => {
            this.fn_delete(row.id);
          })
          .catch((e) => {
            console.log(e);
          });
      }
    },
    async fn_delete(id) {
      try {
        await mushroom.qr_scan.deleteAsync({ id: id });
        window.toastr.success("Xóa QR Scan thành công");
      } catch (e) {
        MethodService.showError(e.code);
      }
      this.fn_initTable();
    },

    fn_hashUrl(routeQuery, tableRules) {
      routeQuery = this.$route.query;
      tableRules = this.mData.tableRules;
      MethodService.hashUrl(routeQuery, tableRules);
    },
    // tìm kiếm
    fn_tableShowFormSearch() {
      this.mData.tableRules.showFormSearch =
        !this.mData.tableRules.showFormSearch;
      this.$router.replace({
        name: "DanhSachQRScan",
        query: {
          limit: this.mData.tableRules.limit,
          page: this.mData.tableRules.page,
          sort: this.mData.tableRules.sort,
          filters: this.mData.tableRules.filters,
          showFormSearch: this.mData.tableRules.showFormSearch,
        },
      });
      this.fn_initTable();
    },
    fn_tableSearch() {
      if (this.mData.tableRules.dataSearch.value["code"]) {
        this.mData.tableRules.dataSearch.value["code"] =
          this.mData.tableRules.dataSearch.value["code"].trim();
      }

      this.loading = true;
      this.mData.tableRules.filters = MethodService.filterTable(
        JSON.stringify(this.mData.tableRules.dataSearch)
      );
      this.mData.tableRules.offset = 0;
      this.fn_initTable();
      MethodService.stopLadda();
    },
    async fn_copyQR() {
      this.isCopyQR = true;
      try {
        await navigator.clipboard.writeText(this.valueQR);
      } catch ($e) {
        console.log($e);
      }
      setTimeout(() => {
        this.isCopyQR = false;
      }, 2000);
    },
    fn_downQR() {
      // dùng khi download file qrscan định dạng svg
      // let svgString = document.querySelector(".qr-scan svg").outerHTML;
      // svgString = svgString.replace(
      //   /^<svg/,
      //   '<svg xmlns="http://www.w3.org/2000/svg"' // đoạn này phải bắt buộc để trình duyệt nhận đọc
      // );
      // var dataURL = "data:image/svg+xml," + encodeURIComponent(svgString);
      // var dl = document.createElement("a");
      // document.body.appendChild(dl); // This line makes it work in Firefox.
      // dl.setAttribute("href", dataURL);
      // dl.setAttribute("download", "test.svg");
      // dl.click();

      const link = document.createElement("a");
      link.download = "qrscan.png";
      link.href = document
        .querySelector(".qr-scan-download canvas")
        .toDataURL();
      link.click();
    },
    fn_changeUrlWhenAddValueURL() {
      if (this.addValueURL) {
        this.addValueURL = this.addValueURL.toLocaleLowerCase();
        this.valueQR = "";
        this.valueQR =
          "https://qr.viettoc.vn/" +
          sessionStorage.codeQR +
          "?" +
          this.addValueURL;
      } else this.valueQR = this.valueQRTemplate;
    },
    handleClose() {
      this.addValueURL = "";
      this.valueQR = "";
      this.valueQRTemplate = "";
      this.dialogVisibleQR = false;
      this.showOptionQR = false;
    },
  },
  //run after render view
  async created() {
    this.fn_hashUrl();
    await this.fn_initTable();
  },
};
</script>
<style scoped>
.card {
  min-height: 88vh;
}
.card-header {
  background-color: #fafafa;
  border: 1px solid rgba(26, 54, 126, 0.125);
  border-bottom: none;
  text-align: center;
}
.title-body {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: column;
}
.title-btn {
  margin-top: 10px;
}
:deep .el-dialog__footer,
:deep .el-dialog__body {
  text-align: center;
}
:deep .el-dialog__footer {
  padding: 0 20px 20px;
}
.qr-box {
  background: linear-gradient(#fff 0 0) padding-box,
    linear-gradient(
      180deg,
      #f9bc60,
      #ffca78 20.31%,
      #fed9b7 53.12%,
      #fac96a 76.04%,
      #e0ab45
    );
  color: #313149;
  padding: 10px;
  border: 5px solid transparent;
  border-radius: 15px;
  display: inline-block;
}
.qr-scan {
  display: flex;
  align-items: center;
}
.qr-container-content {
  position: relative;
  margin-top: 20px;
}
.qr-container-content button {
  position: absolute;
  right: 0;
  top: 0;
}
.qr-content {
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  max-width: 310px;
  margin: auto;
}

.qr-scan-download {
  display: none;
}
:deep .el-input-group__prepend {
  max-width: 195px;
  overflow: hidden;
}
@media (min-width: 960px) {
  .title-body {
    flex-direction: row;
  }
}
</style>
